import React from 'react'
import { Flex, useTooltip, PercentIcon, Text, InfoFillIcon } from 'uikit'
import { useTranslation } from 'contexts/Localization'
import { Pool } from 'state/types'
import { getAprData } from 'views/Pools/helpers'
import { ManualPoolTag } from 'components/Tags'
import styled from 'styled-components'

interface AprRowProps {
  pool: Pool
}

const Wrapper = styled(Flex)`
  padding: 12px 22px 12px 20px;
  border-radius: 0px 0px 12px 12px;
  background-color: #6700c1;
`

const AprRow: React.FC<AprRowProps> = ({ pool }) => {
  const { t } = useTranslation()

  const { apr: earningsPercentageToDisplay } = getAprData(pool)

  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    t('You must harvest and compound your earnings from this pool manually.'),
    {
      placement: 'bottom',
    },
  )

  const displayAPR = earningsPercentageToDisplay
    ? earningsPercentageToDisplay.toLocaleString('en-US', { maximumFractionDigits: 2 })
    : null

  return (
    <Wrapper alignItems="center" justifyContent="space-between">
      <Flex justifyContent="flex-start">
        <Flex>
          <PercentIcon width="32px" color="secondary" mr="8px" />
        </Flex>
        <Flex justifyContent="space-between" flexDirection="column" alignContent="flex-start">
          <Flex>
            <Text fontFamily="Quicksand" fontSize="10px" fontWeight="700">
              {t('APR')}
            </Text>
          </Flex>
          <Flex>
            <Text fontFamily="Quicksand" fontSize="12px" fontWeight="700">
              {displayAPR}%
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex justifyContent="flex-end">
        <ManualPoolTag scale="xxxs" />
        <Flex ref={targetRef}>
          <InfoFillIcon ml="4px" width="14px" height="14px" color="textSubtle" />
        </Flex>
        {tooltipVisible && tooltip}
      </Flex>
    </Wrapper>
  )
}

export default AprRow
